import { render, staticRenderFns } from "./CardPlayground.vue?vue&type=template&id=5f52f10a&scoped=true&"
import script from "./CardPlayground.vue?vue&type=script&lang=js&"
export * from "./CardPlayground.vue?vue&type=script&lang=js&"
import style0 from "./CardPlayground.vue?vue&type=style&index=0&id=5f52f10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52f10a",
  null
  
)

export default component.exports